import styled from "styled-components";
import {Field, Form} from 'formik';

export const FormFormik = styled(Form)`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 1rem;
  /* select, textarea, input:not(input[type="range"]), input:not(input[type="checkbox"]) {
     border-radius: 10px;
     padding: 0.5rem;
     border: 1px solid rgba(166, 172, 181, 0.3);
     background-color: #ffff;
     outline: none;
     width: 100%;
 
     &:focus, &:hover {
       border-color: rgba(51, 148, 246, 1);
     }
   }*/
`

export const InputTextFormik = styled(Field)`
  border-radius: 10px;
  padding: 0.5rem;
  border: 1px solid rgba(166, 172, 181, 0.3);
  background-color: #ffff;
  outline: none;
  width: 100%;



  &:focus, &:hover {
    border-color: rgba(51, 148, 246, 1);
  }
`

export const InputTextareaFormik = styled(InputTextFormik)`
//  height: 55px;
  padding:10rem;
  margin:0;
  ::placeholder {
    white-space: break-spaces;
    padding: 0.3rem;
  }
  
`